module.exports = __webpack_public_path__ + "img/metal_ax@2x.2300473d.png";